import { 
  getListInformationArticle, 
  getListInformationTitle, 
  getArcitleById, 
  getArcitleByType, 
  getQueryByKeyWords 
} from "@/api/app-crm.js";

export const mixinResourceHelp = {
  // created() {
  //     this.hello();
  // },
  methods: {
    getListInformationArticleData(params) {
      let param = {
        // isNoob: true,
        ...params,
        pages: {
          pageNum: 1,
          pageSize: 999999,
        },
      };

      getListInformationArticle(param).then((res) => {
        if (res.code == 200) {
          let sourceData = res.data.list
          this.activities = sourceData;
        }
        this.loading = false;
      });
    },

    async getListInformationTitleData(params){
      let param = {
        // type: 1,
        ...params
        // pages: {
        //   pageNum: 1,
        //   pageSize: 3,
        // },
      };

      let data = await getListInformationTitle(param);
      let sourceData = data.data && data.data.titleTree ? data.data.titleTree : [];
      // const pags = data.data && data.data.pages ? data.data.pages : {};
      // const pagination = { ...this.pagination };
      // this.showLoadingMore = pags.totalPages > pagination.current;
      // pagination.current = pagination.current + 1;
      // console.log("===pagination", pagination);
      // this.pagination = pagination;
      this.menuList = sourceData;
      // this.pagination = pagination;
      this.loading = false;
      // callback && callback();
      // });
    },

    /**
     * 常见问题文章接口
     * @param {*} params 
     */
    async getArcitleData(params){
      let param = {
        ...params
      };

      let data = await getArcitleById(param);
      let sourceData = data.data ? data.data : [];
      this.arcitleData = sourceData;
      this.loading = false;
    },

    /**
     * 手册详情接口
     * @param {*} params 
     */
    async getArcitleTypeData(params){
      let param = {
        ...params
      };

      let data = await getArcitleByType(param);
      let sourceData = data.data ? data.data : [];
      this.arcitleData = sourceData;
      this.loading = false;

    },

    /**
     * 搜索接口
     * @param {*} params 
     */
    async getQueryByKeyWordsData(params){
      let param = {
        ...params
      };

      let data = await getQueryByKeyWords(param);
      let sourceData = data.data ? data.data : [];
      this.dataList = sourceData;
      this.loading = false;

    }
  }
};